import { StyledJiraStats } from './JiraStats.style';
import useJiraStats, { DEFAULT_PAGINATION } from './useJiraStats/useJiraStats';
import Header from './Header';
import useTableCols from './useTableCols/useTableCols';
import Table from 'components/base/Table';
import useTableRows from './useTableRows/useTableRows';
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import LoadingTable from './LoadingTable';
import _ from 'lodash';

const JiraStats = () => {
  const {
    resourceType,
    setResourceType,
    keyword,
    setKeyword,
    pagination,
    data,
    isLoading,
    tableSortBy,
    filtersBarHeight
  } = useJiraStats();
  const cols = useTableCols({ resourceType });
  const rows = useTableRows({ data, resourceType });

  const isDataExists = _.size(data) > 0;

  return (
    <StyledJiraStats offset={filtersBarHeight} data-cy='aggregation-table'>
      <Header
        resourceType={resourceType}
        setResourceType={setResourceType}
        keyword={keyword}
        setKeyword={setKeyword}
        tableSortBy={tableSortBy}
      />
      {isLoading ? (
        <LoadingTable cols={cols} rowsNumber={pagination.pageSize} />
      ) : (
        <TableNoLeftRightBorders>
          <Table
            data={rows}
            columns={cols}
            withPagination
            totalRows={pagination.total}
            rowsPerPage={pagination.pageSize}
            rowsPerPageOptions={DEFAULT_PAGINATION.PAGES}
            onChangeRowsPerPage={event =>
              pagination.setPageSize(event.target.value)
            }
            onChangePage={(event, nextPage) => pagination.setPage(nextPage + 1)}
            page={!isDataExists ? 0 : pagination.page - 1}
            sortBy={tableSortBy.key}
            sortOrder={tableSortBy.dir}
            onSort={(key, dir) => tableSortBy.onChange({ key, dir })}
            withStickyHeader={false}
          />
        </TableNoLeftRightBorders>
      )}
    </StyledJiraStats>
  );
};

export default JiraStats;
